define("settings/templates/overview", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <MigrationBanner />
  {{#if (user-agent "device.isMobile")}}
    <Shared::Ui::FeatureHeader @showMobileMenu={{true}} @title={{t "account.navigation.Header"}} />
    <div class="o--page__notice u--p__t">
      <AddressBanner />
    </div>
    <Shared::PlatformNotice />
  {{/if}}
  
  <Shared::Card class="tAC--card" as |card|>
    <card.header @title={{t "account.overview.title"}} @titleClass="tAC--header__title" />
    <card.body>
  
      <Section
        @title={{t "account.overview.basic_information.title"}}
        class="qa--settings__section--personalInformation"
        as |section|
      >
  
        {{! Name }}
        <section.wrapper class="qa--settings__subSection--name dd-privacy-mask-user-input">
          <section.details
            @description={{this.user.name}}
            @descriptionStyles="u--text--md u--m__b__0"
            @title={{t "shared_words.name"}}
            @titleStyles="u--text--sm u--text--bold"
          />
          {{#if this.isKeycloak}}
            <Shared::Link
              @href={{this.managePersonalInfoUrl}}
              @text={{t "shared_words.edit"}}
              class="o--btn o--btn--outline u--m__r"
              target="_blank"
            />
          {{/if}}
        </section.wrapper>
  
        {{! Email }}
        <section.wrapper class="qa--settings__subSection--email dd-privacy-mask-user-input">
          <section.details
            @description={{this.user.email}}
            @descriptionStyles="u--text--md u--m__b__0"
            @title={{t "shared_words.email"}}
            @titleStyles="u--text--sm u--text--bold"
          />
          {{#if this.isKeycloak}}
            {{#if this.canEditKeycloakEmail}}
              <section.action
                @buttonRoute="overview.edit-email"
                @buttonStyles="qa--settings__button--edit"
                @buttonText={{t "shared_words.change"}}
              />
            {{/if}}
          {{/if}}
  
          {{#if (and this.isKeycloak (not this.canEditKeycloakEmail))}}
            <div class="u--block">
              <AlertBanner @text={{t "account.users.edit_email.account_manager"}} class="u--flex__grow--1 u--m__lr__0" />
            </div>
          {{/if}}
        </section.wrapper>
  
        {{! Change Password }}
        <section.wrapper class="qa--settings__subSection--password">
          <section.details @title={{t "shared_phrases.change_password"}} @titleStyles="u--text--md" />
          {{#if this.isKeycloak}}
            <Shared::Link
              @href={{this.manageSignInUrl}}
              @text={{t "shared_words.update"}}
              class="o--btn o--btn--outline u--m__r"
              target="_blank"
            />
          {{/if}}
        </section.wrapper>
  
        {{#if this.canEnableTwoFactor}}
          <section.wrapper class="qa--settings__subSection--2fa">
            <div class="tAC--section__itemChild">
              <div class="u--flex u--flex__alignItems--center">
                <section.details
                  @description={{t "account.overview.preferences.two_factor.title"}}
                  @descriptionStyles="u--text--md u--m__b__0"
                  @titleStyles="u--text--sm u--text--bold"
                />
                {{#if this.isKeycloak}}
                  <Shared::Link
                    @href={{this.manageSignInUrl}}
                    @text={{t "shared_words.manage"}}
                    class="o--btn o--btn--outline u--m__r"
                    target="_blank"
                  />
                {{/if}}
              </div>
              {{#if this.isKeycloak}}
                {{#if this.showTwoFactorAlert}}
                  <Shared::Ui::FlashMessage
                    @close={{this.closeTwoFactorAlert}}
                    @flash={{this.reenableTwoFactorMessage}}
                    class="tAC--section__alert"
                  />
                {{/if}}
              {{/if}}
            </div>
          </section.wrapper>
        {{/if}}
  
      </Section>
  
      <Section
        @title={{t "account.overview.preferences.title"}}
        class="qa--settings__section--preferences u--hide--mobile"
        as |section|
      >
  
        {{! Timezone }}
        <section.wrapper class="qa--settings__subSection--timeZone">
          <section.details
            @description={{this.user.timeZone}}
            @descriptionStyles="u--text--md u--m__b__0"
            @title={{t "account.overview.preferences.timezone"}}
            @titleStyles="u--text--sm u--text--bold"
          />
          <section.action
            @buttonRoute="overview.preferences"
            @buttonStyles="qa--settings__button--edit"
            @buttonText={{t "shared_words.edit"}}
          />
        </section.wrapper>
  
        {{! First Day of the Week }}
        <section.wrapper class="qa--settings__subSection--startingDay">
          <section.details
            @description={{this.firstDayWeek}}
            @descriptionStyles="u--text--md u--m__b__0"
            @title={{t "account.overview.preferences.first_day_of_week"}}
            @titleStyles="u--text--sm u--text--bold"
          />
          <section.action
            @buttonRoute="overview.preferences"
            @buttonStyles="qa--settings__button--edit"
            @buttonText={{t "shared_words.edit"}}
          />
        </section.wrapper>
  
      </Section>
  
      <Section
        @title={{t "account.overview.display.title"}}
        class="qa--settings__section--display u--hide--mobile"
        as |section|
      >
        {{! Language}}
        <section.wrapper class="qa--settings__subSection--language">
          <section.details @description={{this.userLocaleName}} @descriptionStyles="u--text--md u--m__b__0">
            <:title>
              <span>
                <span class="u--text--sm u--text--bold">{{t "account.overview.display.language"}}</span>
                <Shared::Badge @className="cVL--badge--sm is--beta" />
              </span>
            </:title>
          </section.details>
  
          <section.action
            @buttonRoute="overview.display"
            @buttonStyles="qa--settings__button--edit"
            @buttonText={{t "shared_words.edit"}}
          />
        </section.wrapper>
      </Section>
  
      {{#if (and this.user.isAccountOwner this.account.canAnalyticsEmail)}}
        {{! Section: Weekly Analytics Report }}
        <Section class="qa--settings__section--analytics u--hide--mobile" as |section|>
  
          <section.wrapper>
            <section.details
              @description={{t "account.overview.analytics_emails.description"}}
              @title={{t "account.overview.analytics_emails.title"}}
              @titleStyles="tAC--section__title u--m__b__xs u--text--bold"
            />
            <section.action>
              {{#if this.instagramProfiles.length}}
                <button
                  class="o--btn o--btn--outline u--m__r qa--settings__button--enableAll"
                  onclick={{perform this.handleAllAnalyticsEmailsToggle this.instagramProfiles this.allAnalyticsEmails}}
                  type="button"
                >
                  {{t
                    (concat
                      "account.overview.analytics_emails."
                      (if this.allAnalyticsEmails "disable_all_button" "enable_all_button")
                    )
                  }}
                </button>
              {{/if}}
            </section.action>
          </section.wrapper>
  
          {{#each this.instagramProfiles as |instagramProfile|}}
            {{! Social Profile Switch }}
            <section.wrapper class="qa--settings__subSection--account">
              <section.details>
                <Shared::ProfileAvatar @showDetails={{true}} @showPlatform={{true}} @socialProfile={{instagramProfile}} />
              </section.details>
              <section.action>
                <Shared::Ui::CheckboxSwitch
                  @isDisabled={{false}}
                  @propertyToggled={{instagramProfile.analyticsEmail}}
                  @toggleAction={{action (perform this.handleAnalyticsEmailToggle instagramProfile)}}
                  class="qa--settings__toggle"
                />
              </section.action>
            </section.wrapper>
          {{else}}
            <div class="o--blank">
              <h2 class="o--blank__title">
                {{t "account.overview.analytics_emails.empty.title"}}
              </h2>
              <p class="o--blank__desc">
                {{t "account.overview.analytics_emails.empty.desc"}}
              </p>
            </div>
          {{/each}}
  
        </Section>
      {{/if}}
  
      <Section class="qa--settings__section--postsUsed u--hide--mobile" as |section|>
        {{! Social Profile Post Count }}
        <section.wrapper>
          <MonthlyPostUsage @socialProfiles={{this.socialProfiles}} class="qa--settings__subSection--usage" />
        </section.wrapper>
      </Section>
      {{#if this.canAiCredits}}
        <Section as |section|>
          {{! Credit Count }}
          <section.wrapper>
            <CreditUsage />
          </section.wrapper>
        </Section>
      {{/if}}
  
      {{#if this.user.isAccountOwner}}
        {{! Section: Leave Later }}
        <Section
          @title={{t "account.overview.leave_later.title"}}
          @titleStyles="u--text--danger"
          class="qa--settings__section--leave u--hide--mobile"
          as |section|
        >
          <section.wrapper class="qa--settings__subSection--delete">
            <section.details @title={{this.leaveLaterDescription}} @titleStyles="u--text--danger u--text--md" />
            {{#if (and this.isKeycloak (not this.canEditKeycloakEmail))}}
              <div class="u--block">
                <AlertBanner
                  @text={{t "account.overview.leave_later.account_manager"}}
                  class="u--flex__grow--1 u--m__lr__0"
                />
              </div>
            {{else}}
              <LinkTo
                @disabled={{this.isMobileSubscription}}
                @route="overview.leave"
                class="o--btn o--btn--mute qa--settings_button--delete
                  {{if this.isMobileSubscription 'o--btn--disabled'}}"
              >
                {{t "account.overview.leave_later.button"}}
              </LinkTo>
            {{/if}}
          </section.wrapper>
        </Section>
      {{/if}}
  
      {{#if (and (user-agent "device.isMobile") (not this.isMobileSubscription))}}
        <BillingSection />
      {{/if}}
  
    </card.body>
  </Shared::Card>
  
  {{#if (user-agent "device.isMobile")}}
    <Shared::Ui::Button
      @additional="block"
      @class="u--m__b__lg"
      @onClick={{this.logout}}
      @size="large"
      @text={{t "shared_words.logout"}}
      @variant="outline"
    />
  {{/if}}
  
  {{outlet}}
  */
  {
    "id": "3hn9RZqn",
    "block": "[[[8,[39,0],null,null,null],[1,\"\\n\"],[41,[28,[37,2],[\"device.isMobile\"],null],[[[1,\"  \"],[8,[39,3],null,[[\"@showMobileMenu\",\"@title\"],[true,[28,[37,4],[\"account.navigation.Header\"],null]]],null],[1,\"\\n  \"],[10,0],[14,0,\"o--page__notice u--p__t\"],[12],[1,\"\\n    \"],[8,[39,5],null,null,null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[8,[39,6],null,null,null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[8,[39,7],[[24,0,\"tAC--card\"]],null,[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"header\"]],null,[[\"@title\",\"@titleClass\"],[[28,[37,4],[\"account.overview.title\"],null],\"tAC--header__title\"]],null],[1,\"\\n  \"],[8,[30,1,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n\\n    \"],[8,[39,8],[[24,0,\"qa--settings__section--personalInformation\"]],[[\"@title\"],[[28,[37,4],[\"account.overview.basic_information.title\"],null]]],[[\"default\"],[[[[1,\"\\n\\n\"],[1,\"      \"],[8,[30,2,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--name dd-privacy-mask-user-input\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\",\"@title\",\"@titleStyles\"],[[30,0,[\"user\",\"name\"]],\"u--text--md u--m__b__0\",[28,[37,4],[\"shared_words.name\"],null],\"u--text--sm u--text--bold\"]],null],[1,\"\\n\"],[41,[30,0,[\"isKeycloak\"]],[[[1,\"          \"],[8,[39,9],[[24,0,\"o--btn o--btn--outline u--m__r\"],[24,\"target\",\"_blank\"]],[[\"@href\",\"@text\"],[[30,0,[\"managePersonalInfoUrl\"]],[28,[37,4],[\"shared_words.edit\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"      \"]],[]]]]],[1,\"\\n\\n\"],[1,\"      \"],[8,[30,2,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--email dd-privacy-mask-user-input\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\",\"@title\",\"@titleStyles\"],[[30,0,[\"user\",\"email\"]],\"u--text--md u--m__b__0\",[28,[37,4],[\"shared_words.email\"],null],\"u--text--sm u--text--bold\"]],null],[1,\"\\n\"],[41,[30,0,[\"isKeycloak\"]],[[[41,[30,0,[\"canEditKeycloakEmail\"]],[[[1,\"            \"],[8,[30,2,[\"action\"]],null,[[\"@buttonRoute\",\"@buttonStyles\",\"@buttonText\"],[\"overview.edit-email\",\"qa--settings__button--edit\",[28,[37,4],[\"shared_words.change\"],null]]],null],[1,\"\\n\"]],[]],null]],[]],null],[1,\"\\n\"],[41,[28,[37,10],[[30,0,[\"isKeycloak\"]],[28,[37,11],[[30,0,[\"canEditKeycloakEmail\"]]],null]],null],[[[1,\"          \"],[10,0],[14,0,\"u--block\"],[12],[1,\"\\n            \"],[8,[39,12],[[24,0,\"u--flex__grow--1 u--m__lr__0\"]],[[\"@text\"],[[28,[37,4],[\"account.users.edit_email.account_manager\"],null]]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"]],[]]]]],[1,\"\\n\\n\"],[1,\"      \"],[8,[30,2,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--password\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"details\"]],null,[[\"@title\",\"@titleStyles\"],[[28,[37,4],[\"shared_phrases.change_password\"],null],\"u--text--md\"]],null],[1,\"\\n\"],[41,[30,0,[\"isKeycloak\"]],[[[1,\"          \"],[8,[39,9],[[24,0,\"o--btn o--btn--outline u--m__r\"],[24,\"target\",\"_blank\"]],[[\"@href\",\"@text\"],[[30,0,[\"manageSignInUrl\"]],[28,[37,4],[\"shared_words.update\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"      \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"canEnableTwoFactor\"]],[[[1,\"        \"],[8,[30,2,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--2fa\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[10,0],[14,0,\"tAC--section__itemChild\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"u--flex u--flex__alignItems--center\"],[12],[1,\"\\n              \"],[8,[30,2,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\",\"@titleStyles\"],[[28,[37,4],[\"account.overview.preferences.two_factor.title\"],null],\"u--text--md u--m__b__0\",\"u--text--sm u--text--bold\"]],null],[1,\"\\n\"],[41,[30,0,[\"isKeycloak\"]],[[[1,\"                \"],[8,[39,9],[[24,0,\"o--btn o--btn--outline u--m__r\"],[24,\"target\",\"_blank\"]],[[\"@href\",\"@text\"],[[30,0,[\"manageSignInUrl\"]],[28,[37,4],[\"shared_words.manage\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n\"],[41,[30,0,[\"isKeycloak\"]],[[[41,[30,0,[\"showTwoFactorAlert\"]],[[[1,\"                \"],[8,[39,13],[[24,0,\"tAC--section__alert\"]],[[\"@close\",\"@flash\"],[[30,0,[\"closeTwoFactorAlert\"]],[30,0,[\"reenableTwoFactorMessage\"]]]],null],[1,\"\\n\"]],[]],null]],[]],null],[1,\"          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n    \"]],[2]]]]],[1,\"\\n\\n    \"],[8,[39,8],[[24,0,\"qa--settings__section--preferences u--hide--mobile\"]],[[\"@title\"],[[28,[37,4],[\"account.overview.preferences.title\"],null]]],[[\"default\"],[[[[1,\"\\n\\n\"],[1,\"      \"],[8,[30,3,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--timeZone\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,3,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\",\"@title\",\"@titleStyles\"],[[30,0,[\"user\",\"timeZone\"]],\"u--text--md u--m__b__0\",[28,[37,4],[\"account.overview.preferences.timezone\"],null],\"u--text--sm u--text--bold\"]],null],[1,\"\\n        \"],[8,[30,3,[\"action\"]],null,[[\"@buttonRoute\",\"@buttonStyles\",\"@buttonText\"],[\"overview.preferences\",\"qa--settings__button--edit\",[28,[37,4],[\"shared_words.edit\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n\"],[1,\"      \"],[8,[30,3,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--startingDay\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,3,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\",\"@title\",\"@titleStyles\"],[[30,0,[\"firstDayWeek\"]],\"u--text--md u--m__b__0\",[28,[37,4],[\"account.overview.preferences.first_day_of_week\"],null],\"u--text--sm u--text--bold\"]],null],[1,\"\\n        \"],[8,[30,3,[\"action\"]],null,[[\"@buttonRoute\",\"@buttonStyles\",\"@buttonText\"],[\"overview.preferences\",\"qa--settings__button--edit\",[28,[37,4],[\"shared_words.edit\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n    \"]],[3]]]]],[1,\"\\n\\n    \"],[8,[39,8],[[24,0,\"qa--settings__section--display u--hide--mobile\"]],[[\"@title\"],[[28,[37,4],[\"account.overview.display.title\"],null]]],[[\"default\"],[[[[1,\"\\n\"],[1,\"      \"],[8,[30,4,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--language\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,4,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\"],[[30,0,[\"userLocaleName\"]],\"u--text--md u--m__b__0\"]],[[\"title\"],[[[[1,\"\\n            \"],[10,1],[12],[1,\"\\n              \"],[10,1],[14,0,\"u--text--sm u--text--bold\"],[12],[1,[28,[35,4],[\"account.overview.display.language\"],null]],[13],[1,\"\\n              \"],[8,[39,14],null,[[\"@className\"],[\"cVL--badge--sm is--beta\"]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n\\n        \"],[8,[30,4,[\"action\"]],null,[[\"@buttonRoute\",\"@buttonStyles\",\"@buttonText\"],[\"overview.display\",\"qa--settings__button--edit\",[28,[37,4],[\"shared_words.edit\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[4]]]]],[1,\"\\n\\n\"],[41,[28,[37,10],[[30,0,[\"user\",\"isAccountOwner\"]],[30,0,[\"account\",\"canAnalyticsEmail\"]]],null],[[[1,\"      \"],[8,[39,8],[[24,0,\"qa--settings__section--analytics u--hide--mobile\"]],null,[[\"default\"],[[[[1,\"\\n\\n        \"],[8,[30,5,[\"wrapper\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[30,5,[\"details\"]],null,[[\"@description\",\"@title\",\"@titleStyles\"],[[28,[37,4],[\"account.overview.analytics_emails.description\"],null],[28,[37,4],[\"account.overview.analytics_emails.title\"],null],\"tAC--section__title u--m__b__xs u--text--bold\"]],null],[1,\"\\n          \"],[8,[30,5,[\"action\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"instagramProfiles\",\"length\"]],[[[1,\"              \"],[10,\"button\"],[14,0,\"o--btn o--btn--outline u--m__r qa--settings__button--enableAll\"],[15,\"onclick\",[28,[37,15],[[30,0,[\"handleAllAnalyticsEmailsToggle\"]],[30,0,[\"instagramProfiles\"]],[30,0,[\"allAnalyticsEmails\"]]],null]],[14,4,\"button\"],[12],[1,\"\\n                \"],[1,[28,[35,4],[[28,[37,16],[\"account.overview.analytics_emails.\",[52,[30,0,[\"allAnalyticsEmails\"]],\"disable_all_button\",\"enable_all_button\"]],null]],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"]],[]]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n\\n\"],[42,[28,[37,18],[[28,[37,18],[[30,0,[\"instagramProfiles\"]]],null]],null],null,[[[1,\"          \"],[8,[30,5,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--account\"]],null,[[\"default\"],[[[[1,\"\\n            \"],[8,[30,5,[\"details\"]],null,null,[[\"default\"],[[[[1,\"\\n              \"],[8,[39,19],null,[[\"@showDetails\",\"@showPlatform\",\"@socialProfile\"],[true,true,[30,6]]],null],[1,\"\\n            \"]],[]]]]],[1,\"\\n            \"],[8,[30,5,[\"action\"]],null,null,[[\"default\"],[[[[1,\"\\n              \"],[8,[39,20],[[24,0,\"qa--settings__toggle\"]],[[\"@isDisabled\",\"@propertyToggled\",\"@toggleAction\"],[false,[30,6,[\"analyticsEmail\"]],[28,[37,21],[[30,0],[28,[37,15],[[30,0,[\"handleAnalyticsEmailToggle\"]],[30,6]],null]],null]]],null],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[6]],[[[1,\"          \"],[10,0],[14,0,\"o--blank\"],[12],[1,\"\\n            \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n              \"],[1,[28,[35,4],[\"account.overview.analytics_emails.empty.title\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n              \"],[1,[28,[35,4],[\"account.overview.analytics_emails.empty.desc\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n      \"]],[5]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[39,8],[[24,0,\"qa--settings__section--postsUsed u--hide--mobile\"]],null,[[\"default\"],[[[[1,\"\\n\"],[1,\"      \"],[8,[30,7,[\"wrapper\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,22],[[24,0,\"qa--settings__subSection--usage\"]],[[\"@socialProfiles\"],[[30,0,[\"socialProfiles\"]]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[7]]]]],[1,\"\\n\"],[41,[30,0,[\"canAiCredits\"]],[[[1,\"      \"],[8,[39,8],null,null,[[\"default\"],[[[[1,\"\\n\"],[1,\"        \"],[8,[30,8,[\"wrapper\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[39,23],null,null,null],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[8]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"user\",\"isAccountOwner\"]],[[[1,\"      \"],[8,[39,8],[[24,0,\"qa--settings__section--leave u--hide--mobile\"]],[[\"@title\",\"@titleStyles\"],[[28,[37,4],[\"account.overview.leave_later.title\"],null],\"u--text--danger\"]],[[\"default\"],[[[[1,\"\\n        \"],[8,[30,9,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--delete\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[8,[30,9,[\"details\"]],null,[[\"@title\",\"@titleStyles\"],[[30,0,[\"leaveLaterDescription\"]],\"u--text--danger u--text--md\"]],null],[1,\"\\n\"],[41,[28,[37,10],[[30,0,[\"isKeycloak\"]],[28,[37,11],[[30,0,[\"canEditKeycloakEmail\"]]],null]],null],[[[1,\"            \"],[10,0],[14,0,\"u--block\"],[12],[1,\"\\n              \"],[8,[39,12],[[24,0,\"u--flex__grow--1 u--m__lr__0\"]],[[\"@text\"],[[28,[37,4],[\"account.overview.leave_later.account_manager\"],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[8,[39,24],[[16,0,[29,[\"o--btn o--btn--mute qa--settings_button--delete\\n                \",[52,[30,0,[\"isMobileSubscription\"]],\"o--btn--disabled\"]]]]],[[\"@disabled\",\"@route\"],[[30,0,[\"isMobileSubscription\"]],\"overview.leave\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,4],[\"account.overview.leave_later.button\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"        \"]],[]]]]],[1,\"\\n      \"]],[9]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,10],[[28,[37,2],[\"device.isMobile\"],null],[28,[37,11],[[30,0,[\"isMobileSubscription\"]]],null]],null],[[[1,\"      \"],[8,[39,25],null,null,null],[1,\"\\n\"]],[]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]],[1,\"\\n\\n\"],[41,[28,[37,2],[\"device.isMobile\"],null],[[[1,\"  \"],[8,[39,26],null,[[\"@additional\",\"@class\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[\"block\",\"u--m__b__lg\",[30,0,[\"logout\"]],\"large\",[28,[37,4],[\"shared_words.logout\"],null],\"outline\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[46,[28,[37,28],null,null],null,null,null]],[\"card\",\"section\",\"section\",\"section\",\"section\",\"instagramProfile\",\"section\",\"section\",\"section\"],false,[\"migration-banner\",\"if\",\"user-agent\",\"shared/ui/feature-header\",\"t\",\"address-banner\",\"shared/platform-notice\",\"shared/card\",\"section\",\"shared/link\",\"and\",\"not\",\"alert-banner\",\"shared/ui/flash-message\",\"shared/badge\",\"perform\",\"concat\",\"each\",\"-track-array\",\"shared/profile-avatar\",\"shared/ui/checkbox-switch\",\"action\",\"monthly-post-usage\",\"credit-usage\",\"link-to\",\"billing-section\",\"shared/ui/button\",\"component\",\"-outlet\"]]",
    "moduleName": "settings/templates/overview.hbs",
    "isStrictMode": false
  });
});